<template>
  <div id="app">
    <EarthView />
  </div>
</template>

<script>
import EarthView from './components/EarthView.vue'

export default {
  name: 'App',
  components: {
    EarthView
  }
}
</script>

<style>


#app {
  width: 100%;
  height: 100%;
}

html,
body{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
@import url("./assets/fonts/font.css")
</style>

